<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Location">
                <rect width="50" height="50"/>
            </clipPath>
        </defs>
        <g id="Location" clip-path="url(#clip-Location)">
            <g id="noun_Location_1755662" transform="translate(-55 -65.934)">
                <g id="Groupe_2917" data-name="Groupe 2917" transform="translate(68.006 74.206)">
                    <path id="Tracé_2996" data-name="Tracé 2996" d="M33.458,963.376A12.472,12.472,0,0,0,21,975.834a9.978,9.978,0,0,0,1.866,6.054L32.747,996.5a.859.859,0,0,0,1.423,0l9.881-14.607a9.978,9.978,0,0,0,1.866-6.054A12.472,12.472,0,0,0,33.458,963.376Zm0,1.719a10.727,10.727,0,0,1,10.74,10.74,7.909,7.909,0,0,1-1.571,5.1l-9.169,13.559-9.169-13.559a7.91,7.91,0,0,1-1.571-5.1A10.727,10.727,0,0,1,33.458,965.094Zm0,4.3a6.014,6.014,0,1,0,6.014,6.014A6.028,6.028,0,0,0,33.458,969.39Zm0,1.719a4.3,4.3,0,1,1-4.3,4.3A4.283,4.283,0,0,1,33.458,971.109Z" transform="translate(-21 -963.376)" :fill="color"/>
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconLocation',
    mixins: [Colorable],
};
</script>

